<template>
  <div class="columns is-multiline">
    <div class="column is-6">
      <div class="columns">
        <div class="column is-9">
          <b-pagination
            :total="fetchCliparts.length"
            v-model="current_clipart_page"
            :per-page="clipart_page_items"
            aria-next-label="Next page"
            aria-previous-label="Previous page"
            aria-page-label="Page"
            aria-current-label="Current page">
          </b-pagination>
        </div>
        <div class="column is-3">
          <b-numberinput v-model="current_clipart_page" :controls="false"></b-numberinput>
        </div>
      </div>
      <div class="columns is-multiline">
        <div v-for="clipart in currentPageCliparts" :key="clipart._id" style="position: relative;border: 1px solid #ccc;" class="column is-2 has-text-centered">
          <show-image width="80" :src="clipart.file" />
          <p><b-button @click="addClipartToDrawer(clipart)" type="is-info" size="is-small" outlined>Select</b-button></p>
        </div>
      </div>
    </div>

    <div class="column is-6">
      <p class="title is-5">Your Clipart Drawer</p>
      <div class="columns mt-3 is-multiline">
        <div v-for="(clipart_obj,clipi) in selected_cliparts" :key="`CLIPART_MULTI_${clipart_obj.clipart._id}`" style="position: relative;border: 1px solid #ccc;" class="column is-3 has-text-centered">
          <show-image width="80" :src="clipart_obj.clipart.file" />
          <p>Clipart {{clipi + 1}}</p>
          <b-field grouped expanded>
            <b-field label="Width" expanded>
              <b-numberinput :controls="false" size="is-small" v-model="clipart_obj.width"></b-numberinput>
            </b-field>
            <b-field label="Height" expanded>
              <b-numberinput :controls="false" size="is-small" v-model="clipart_obj.height"></b-numberinput>
            </b-field>
          </b-field>
          
          <p><b-button @click="selectClipart(clipart_obj)" type="is-success" size="is-small" outlined>Add/Select</b-button></p>
          <p><b-button @click="removeClipartFromDrawer(clipart_obj.clipart._id)" type="is-danger" size="is-small" outlined>Remove</b-button></p>
        </div>
      </div>
           
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import ShowImage from '@/components/General/ShowImage'
export default{
  name : 'multi-clipart-selector',
  components : {
    ShowImage
  },
  props : {
    value : {
      type : Object,
      default : function(){ 
        return {
          width : 50,
          height : 50,
          clipart : null
        }
      }
    }
  },
  data(){
    return {
      current_clipart : this.value,
      clipart_page_items : 50,
      current_clipart_page : 1,
      selected_cliparts : []
    }
  },
  computed : {
    ...mapGetters(['fetchCliparts', 'getTeacherToken']),
    currentPageCliparts(){
      // Returns all cliparts of this particular page
      return this.fetchCliparts.slice((this.current_clipart_page-1)*this.clipart_page_items, this.current_clipart_page*this.clipart_page_items)
    },
  },
  methods : {
    ...mapActions(['loadCliparts']),
    addClipartToDrawer(clipart){
      this.selected_cliparts.push({
        clipart,
        width : 50, 
        height : 50
      })
    },
    removeClipartFromDrawer(id){
      this.selected_cliparts = this.selected_cliparts.filter(clip_obj => clip_obj.clipart._id != id)
    },
    selectClipart(clipart_obj){
      this.current_clipart = clipart_obj
      this.$emit('input', this.current_clipart)
    }
  },
  watch : {
    value : function(new_val){
      this.current_clipart = new_val
    }
  },
  created(){
    this.loadCliparts({ token : this.getTeacherToken })
  }
}
</script>